<template>
	<div>
		<!-- Start Tab栏 -->
		<div class="row row--15">
			<div class="col-lg-12">
				<ul class="nav nav-pills rwt-portfolio-filter filter-button-default liststyle mb--20" id="pills-tab"
					role="tablist" data-aos="fade-up">
					<li class="nav-item list-item" role="presentation" v-for="(filter, index) in filters"
						:key="`tab-button-${filter.id}`">
						<template v-if="filter.sign !== 'download'">
							<button 
								class="nav-link" 
								:class="{'active': index === activeTab}" 
								type="button" 
								@click="handleNormalTabClick(index)"
							>
								{{ filter.text }}
							</button>
						</template>
						<template v-else>
							<button 
								class="nav-link" 
								:class="{'active': downloadTabActive}" 
								type="button" 
								@click.prevent.stop="handleDownloadClick"
							>
								{{ filter.text }}
							</button>
						</template>
					</li>
				</ul>
			</div>
		</div>
		<!-- end Tab栏 -->

		<div class="tab-content">
			<div class="tab-pane" :class="{'active': index === activeTab}" v-for="(filter, index) in filters"
				:key="`tab-pane-${filter.id}`">
				<div class="row row--15">
					
					<!-- start 概述 -->
					<template v-if="filter.sign == 'all'">
						<div class="portfolio">
							<div class="container">
								<div class="content">
									<div class="inner">
										<h3 class="main-title"><strong>{{SerialAllInfo.SerialName}}</strong></h3>
										<div class="divider-line"></div>
										<p class="main-intro">
											<span v-html="SerialAllInfo.SerialIntro"></span>
										</p>
									</div>
								</div>
								<div class="row row--40 portfolio-detail-row">
									<!-- PC端：左列所有图片 -->
									<div class="col-lg-5 image-wrapper pc-only">
										<div class="image-container">
											<div v-for="(img, idx) in SerialAllInfo.imgsPath" :key="idx" class="image-slot">
												<img 
													class="product-image" 
													:src="img" 
													:alt="`产品图片 ${idx + 1}`"
													@error="handleImageError($event, idx)"
													:data-fallback-applied="false"
												>
											</div>
										</div>
									</div>
									<!-- PC端：右列所有文字 -->
									<div class="col-lg-7 text-wrapper pc-only">
										<ul class="feature-list">
											<li v-for="(item, index) in SerialAllInfo.TypeInfo" :key="index">
												<div class="sub-module">
													<div class="sub-divider">
														<div class="title-box">
															<h4 class="sub-title">{{item.TypeName}}</h4>
														</div>
													</div>
													<div class="sub-intro">
														<p v-for="(spec, specIndex) in parseTypeIntro(item.TypeIntro)" :key="specIndex" :class="spec.type === 'list' ? 'spec-item' : 'spec-text'">
															{{ spec.content }}
														</p>
													</div>
												</div>
											</li>													
										</ul>
									</div>

									<!-- 移动端：每个子模块上方标题简介，下方左图右列表 -->
									<div class="col-lg-12 mobile-only">
										<ul class="feature-list">
											<li v-for="(item, index) in SerialAllInfo.TypeInfo" :key="index">
												<div class="sub-module sub-module-with-img">
													<div class="sub-content-full">
														<div class="sub-divider">
															<div class="title-box">
																<h4 class="sub-title">{{item.TypeName}}</h4>
															</div>
														</div>
														<div class="sub-intro-text">
															<p v-for="(spec, specIndex) in parseTypeIntro(item.TypeIntro)" :key="specIndex" v-if="spec.type !== 'list'" class="spec-text">
																{{ spec.content }}
															</p>
														</div>
													</div>
													<div class="sub-bottom-row">
														<div class="sub-img">
															<img 
																class="product-image" 
																:src="item.MobileImgPath || SerialAllInfo.imgsPath[index]" 
																:alt="item.TypeName"
																@error="handleImageError($event, index)"
																:data-fallback-applied="false"
																v-if="item.MobileImgPath || SerialAllInfo.imgsPath[index]"
															>
														</div>
														<div class="sub-intro-list">
															<p class="spec-label">主要特性：</p>
															<p v-for="(spec, specIndex) in parseTypeIntro(item.TypeIntro)" :key="specIndex" v-if="spec.type === 'list'" class="spec-item">
																{{ spec.content }}
															</p>
														</div>
													</div>
												</div>
											</li>													
										</ul>
									</div>
								</div>
								<section 
									id="product-download-section" 
									ref="downloadSection" 
									class="product-download-section"
									v-if="SerialAllInfo.DownloadList && SerialAllInfo.DownloadList.length > 0"
								>
									<h3 class="download-title">资料下载</h3>
									<div class="download-divider"></div>
									<div class="download-content">
										<UpDownTool :file-list="SerialAllInfo.DownloadList"></UpDownTool>
									</div>
								</section>
							</div>
						</div>
					</template>
					<!-- end 概述 -->
					
					<!-- start 参数详细 -->
					<template v-if="filter.sign == 'params'">
						<div class="portfolio">
							<div class="container">
								<div class="row row--40 align-items-center">
									<div class="col-lg-12">
										<p class="text">
											<span v-html="SerialAllInfo.ParaTable"></span>
										</p>
									</div>
								</div>
							</div>
						</div>
					</template>
					<!-- end 参数详细 -->
					
					<!-- start 资料下载 -->
					<template v-if="filter.sign == 'download'">
						<div class="portfolio">
							<div class="container">
								<div class="row">
									<UpDownTool :file-list="SerialAllInfo.DownloadList"></UpDownTool>
								</div>
							</div>
						</div>
					</template>
					<!-- end 资料下载 -->
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Icon from '../../icon/Icon'
	import UpDownTool from '../../updown/updownlist.vue'
	import BlogPostMixin from '../../../mixins/BlogPostMixin'
	import PDetailMixin from '../../../mixins/EdgeProductDetailInfo.js'

	export default {
		name: 'Portfolio',
		components: {
			Icon,UpDownTool
		},
		mixins: [BlogPostMixin,PDetailMixin],
		props: {
			portfolioData: {},
			buttonClass: {
				type: String,
				default: 'btn btn-default btn-large btn-icon'
			},
			column: {
				type: String,
				default: 'col-lg-6 col-md-6 col-sm-12 col-12 mt--30'
			}
		},
		data() {
			return {
				filters: [
					{
						id: 1,
						sign: 'all',
						text: '概述',
					},
					{
						id: 2,
						sign: 'params',
						text: '参数详细',
					},
					{
						id: 3,
						sign: 'download',
						text: '资料下载',
					},
				],
				
				activeFilter: '',
				activeTab: 0,
				downloadTabActive: false,
			}
		},
		methods:{
			getFilters(typeID){
				let data = [];
				if(typeID == 53){
					data = [
						{
							id: 1,
							sign: 'all',
							text: '概述',
						},
						{
							id: 2,
							sign: 'params',
							text: '参数详细',
						},
						{
							id: 3,
							sign: 'download',
							text: '资料下载',
						},
					]
				}
				else{
					data = [
						{
							id: 1,
							sign: 'all',
							text: '概述',
						},
						{
							id: 2,
							sign: 'params',
							text: '参数详细',
						},
						{
							id: 3,
							sign: 'download',
							text: '资料下载',
						},
					]
				}
			},
			parseTypeIntro(intro) {
				if (!intro) return [];
				let text = intro.replace(/<br\s*\/?>/gi, '\n');
				let lines = text.split('\n').filter(line => line.trim());
				let result = [];
				lines.forEach(line => {
					let trimmed = line.trim();
					if (trimmed) {
						if (/^[·\-*●•\d+\.\s]/.test(trimmed)) {
							let cleaned = trimmed.replace(/^[·\-*●•]\s*|\d+\.\s*/, '');
							if (cleaned) {
								result.push({ type: 'list', content: cleaned });
							}
						} else {
							result.push({ type: 'text', content: trimmed });
						}
					}
				});
				return result;
			},
			handleImageError(event, index) {
				const img = event.target;
				if (img.dataset.fallbackApplied === 'true') {
					img.style.display = 'none';
					return;
				}
				img.dataset.fallbackApplied = 'true';
				img.src = require('@/assets/images/edge/Active/关于我们页/Logo/logo.png');
				img.onerror = function() {
					this.style.display = 'none';
				};
			},
			handleNormalTabClick(index) {
				this.downloadTabActive = false;
				this.activeTab = index;
			},
			handleDownloadClick() {
				this.downloadTabActive = true;
				this.activeTab = 0;
				
				this.$nextTick(() => {
					const element = document.getElementById('product-download-section');
					if (!element) {
						return;
					}
					
					const headerOffset = 100;
					const rect = element.getBoundingClientRect();
					const currentScrollTop = document.documentElement.scrollTop || window.pageYOffset || 0;
					const targetTop = rect.top + currentScrollTop - headerOffset;
					
					window.scrollTo({
						top: Math.max(0, targetTop),
						behavior: 'smooth'
					});
				});
			}
		},
		created() {
			// console.log('this.$route.params.typeID='+this.$route.params.typeID)
			
			this.getProductDetailData(this.$route.params.typeID);
		}
	}
</script>

<style>
	/* Tab栏居中对齐 */
	.rwt-portfolio-filter {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.main-title {
		font-size: 24px;
		font-weight: 700;
		color: #1a1a2e;
		margin-bottom: 16px;
	}

	.divider-line {
		height: 2px;
		background: linear-gradient(90deg, #ffffff 0%, #007bff 50%, #ffffff 100%);
		margin: 20px 0;
	}

	.main-intro {
		font-size: 15px;
		color: #555;
		line-height: 1.8;
		padding: 16px;
		background: #f8f9fa;
		border-radius: 4px;
		margin-bottom: 24px;
	}

	.tab-pane {
		display: none;
	}

	.tab-pane.active {
		display: block;
	}

	.portfolio-detail-row {
		display: flex;
		align-items: stretch;
	}

	/* PC端显示，移动端隐藏 */
	.pc-only {
		display: block;
	}
	.mobile-only {
		display: none;
	}

	@media (min-width: 992px) {
		.portfolio-detail-row {
			min-height: clamp(400px, 50vw, 700px);
		}

		.image-wrapper {
			position: relative;
			min-height: 0;
			padding-top: 16px;
		}

		.image-container {
			position: absolute;
			top: 16px;
			right: 0;
			bottom: 0;
			left: 0;
			display: flex;
			flex-direction: column;
			min-height: 0;
			overflow: hidden;
		}

		.image-slot {
			flex: 1 1 0;
			min-width: 0;
			min-height: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
		}

		.image-slot + .image-slot {
			margin-top: 12px;
		}

		.product-image {
			display: block;
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}

	/* 平板及手机端：隐藏PC布局，显示移动端布局 */
	@media (max-width: 991.98px) {
		.pc-only {
			display: none;
		}
		.mobile-only {
			display: block;
		}

		/* 每个子模块：上方标题简介，下方左图右列表 */
		.sub-module-with-img {
			display: flex;
			flex-direction: column;
			gap: 12px;
			margin-bottom: 25px;
			padding-bottom: 25px;
			border-bottom: 1px solid #eee;
			/* border: 2px solid red; */
		}

		.sub-module-with-img:last-child {
			margin-bottom: 0;
			padding-bottom: 0;
			border-bottom: none;
		}

		.sub-content-full {
			width: 100%;
			/* border: 2px solid blue; */
		}

		.sub-bottom-row {
			display: flex;
			align-items: stretch;
			gap: 18px;
			/* border: 2px solid green; */
		}

		.sub-img {
			flex-shrink: 0;
			width: 30%;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			/* border: 2px solid brown; */
		}

		.sub-img .product-image {
			width: 100%;
			height: 100%;
			max-height: none;
			object-fit: contain;
			/* border: 2px solid teal; */
		}

		.sub-intro-list {
			flex: 1;
			min-width: 0;
			display: flex;
			flex-direction: column;
			gap: 8px;
			/* border: 2px solid pink; */
		}

		.spec-label {
			font-size: 14px;
			font-weight: 600;
			color: #2d3748;
			margin: 0;
			/* border: 2px solid purple; */
		}
	}

	/* 手机端适配（≤768px） */
	@media (max-width: 768px) {
		.sub-module-with-img {
			gap: 10px;
			margin-bottom: 20px;
			padding-bottom: 20px;
			/* border: 2px solid red !important; */
		}

		.sub-content-full {
			/* border: 2px solid blue !important; */
		}

		.sub-bottom-row {
			gap: 12px;
			align-items: stretch !important;
			/* border: 2px solid green !important; */
		}

		.sub-img {
			width: 30% !important;
			align-items: center !important;
			/* border: 2px solid brown !important; */
		}

		.sub-img .product-image {
			height: 100% !important;
			max-height: none !important;
			/* border: 2px solid teal !important; */
		}

		.sub-intro-list {
			gap: 6px;
			/* border: 2px solid pink !important; */
		}

		.spec-label {
			font-size: 13px;
			/* border: 2px solid purple !important; */
		}

		/* 缩小子标题和内容字体 */
		.sub-title {
			font-size: 14px;
		}

		.title-box {
			padding: 4px 12px;
			margin: 0 8px 8px 0;
		}

		.sub-divider {
			margin-bottom: 10px;
		}

		.spec-text {
			font-size: 12px;
			line-height: 1.5;
			margin-bottom: 4px;
		}

		.spec-item {
			font-size: 12px;
			padding: 4px 8px;
			line-height: 1.4;
		}

		.main-title {
			font-size: 18px;
		}

		.main-intro {
			font-size: 13px;
			padding: 10px;
		}
	}

	/* 小屏手机进一步优化（≤480px） */
	@media (max-width: 480px) {
		.sub-module-with-img {
			gap: 8px;
			margin-bottom: 15px;
			padding-bottom: 15px;
			/* border: 2px solid red !important; */
		}

		.sub-content-full {
			/* border: 2px solid blue !important; */
		}

		.sub-bottom-row {
			gap: 10px;
			align-items: stretch !important;
			/* border: 2px solid green !important; */
		}

		.sub-img {
			width: 30% !important;
			align-items: center !important;
			/* border: 2px solid brown !important; */
		}

		.sub-img .product-image {
			height: 100% !important;
			max-height: none !important;
			/* border: 2px solid teal !important; */
		}

		.sub-intro-list {
			gap: 5px;
			/* border: 2px solid pink !important; */
		}

		.spec-label {
			font-size: 12px;
			/* border: 2px solid purple !important; */
		}

		.sub-title {
			font-size: 13px;
		}

		.spec-text,
		.spec-item {
			font-size: 11px;
		}
	}

	.product-download-section {
		margin-top: 40px;
		padding-top: 0;
		scroll-margin-top: 100px;
	}

	.download-title {
		font-size: 22px;
		font-weight: 600;
		color: #333;
		margin-bottom: 12px;
	}

	.download-divider {
		height: 4px;
		background: linear-gradient(90deg, #ffffff 0%, #007bff 50%, #ffffff 100%);
		margin-bottom: 24px;
	}

	.download-content {
		margin: 0;
	}

	.download-content >>> .container {
		padding: 0;
		width: 100%;
		max-width: 100%;
	}

	.download-content >>> .row {
		margin: 0;
	}

	.download-content >>> .card {
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}

	.download-content >>> .card-header {
		background-color: #f8f9fa;
		border-bottom: 1px solid #e8e8e8;
		padding: 12px 16px;
		font-weight: 600;
	}

	.download-content >>> .list-group-item {
		padding: 12px 16px;
		border-left: none;
		border-right: none;
	}

	.download-content >>> .list-group-item:first-child {
		border-top: none;
	}

	.download-content >>> .list-group-item:last-child {
		border-bottom: none;
	}

	.feature-list {
		list-style: none;
		padding-left: 0;
		margin: 0;
	}

	.feature-list li {
		padding: 0;
		margin-bottom: 0;
	}

	.sub-module {
		margin-bottom: 32px;
		padding-bottom: 32px;
		border-bottom: 1px dashed #e0e0e0;
	}

	.sub-module:last-child {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}

	.sub-divider {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
	}

	.sub-divider::before,
	.sub-divider::after {
		content: '';
		flex: 1;
		height: 1px;
		background: linear-gradient(90deg, transparent, #ccc, transparent);
	}

	.title-box {
		padding: 6px 20px;
		background: #f0f4ff;
		border-radius: 16px;
		margin: 0 16px;
	}

	.sub-title {
		font-size: 18px;
		font-weight: 600;
		color: #2d3748;
		margin: 0;
	}

	.sub-intro {
		padding: 0;
		margin: 0;
	}

	.spec-text {
		font-size: 14px;
		color: #475569;
		line-height: 1.6;
		margin-bottom: 8px;
	}

	.spec-item {
		padding: 6px 12px;
		margin-bottom: 3px;
		background: #f8fafc;
		border-radius: 4px;
		border-left: 3px solid #007bff;
		font-size: 14px;
		color: #475569;
		line-height: 1.5;
	}

	.para-table table{
		border: 1;
		align:center;
		border-collapse: collapse;
		width: 100%;
	}
	.para-table td{
		border:1px solid #dee2e6;
		font-size: 14px !important;
		border-collapse: collapse;
		text-align: center;
		color: #333;
		padding: 10px;
	}
	.para-table font{
		text-align: center;
	}
	.para-table-head td{
		background-color: #003366;
		color: #ffffff;
		font-weight: 600;
	}
	.para-table-tag{
		background-color: #e3f2fd;
		font-weight: 500;
	}

</style>